import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { MarketingLink } from "../types/marketingLink";

export default function adminAppSettingsReducer(
  state: MarketingLink[] = initialState.marketingLinks,
  action: AnyAction
): MarketingLink[] {
  switch (action.type) {
    case internalActionKeys.GET_MARKETING_LINKS_SUCCESS:
      return [...action.links];
    case internalActionKeys.SAVE_MARKETING_LINK_SUCCESS: {
      const link: MarketingLink = action.link;
      const index = state.map(l => l.id).indexOf(link.id);
      if (index >= 0) {
        return [...state.slice(0, index), link, ...state.slice(index + 1)];
      } else {
        return state;
      }
    }
    case internalActionKeys.DELETE_MARKETING_LINK_SUCCESS: {
      const link: MarketingLink = action.link;
      const index = state.map(l => l.id).indexOf(link.id);
      if (index >= 0) {
        return [...state.slice(0, index), ...state.slice(index + 1)];
      } else {
        return state;
      }
    }
    default:
      return state;
  }
}
